import { useDispatch, useSelector } from "react-redux";
import { setSection } from "../../../../assignmentSlice";
import { typeInfo } from "../../../../../../constants/typeInfo";

const OXPage = ({ currentPage, pageList, setPageList, currentIndex }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const buttonList = ["O", "X"];
  const buttonInfo = {
    O: {
      backgroundColor: "rgba(67, 140, 251, 0.15)",
      color: "rgba(67, 140, 251, 1)",
    },
    X: {
      backgroundColor: "rgba(255, 68, 68, 0.1)",
      color: "rgba(255, 68, 68, 1)",
    },
  };

  const clickOX = (OX) => {
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          input: OX,
          isSubmitted: true,
        };
      } else {
        return page;
      }
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "50px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
        }}
      >
        {"본문의 내용과 일치하면 O, 일치하지 않으면 X를 고르시오."}
      </div>
      <div
        style={{
          fontSize: "28px",
          textAlign: "center",
          lineHeight: "1.5",
        }}
      >
        {currentPage.question}
      </div>
      <div
        style={{
          marginTop: "40px",
          display: "flex",
          flexDirection: "row",
          gap: "30px",
        }}
      >
        {buttonList.map((OX) => {
          return (
            <button
              style={{
                height: "50px",
                width: "120px",
                fontSize: "24px",
                borderRadius: "5px",
                backgroundColor:
                  currentPage.input === OX
                    ? typeInfo["comprehensive"].color
                    : buttonInfo[OX].backgroundColor,
                color:
                  currentPage.input === OX
                    ? typeInfo["comprehensive"].answerTextColor
                    : buttonInfo[OX].color,
                border:
                  currentPage.input === OX
                    ? "1px solid " + typeInfo["comprehensive"].color
                    : "1px solid " + buttonInfo[OX].color,
                transition: "all 0.3s",
              }}
              onClick={() => clickOX(OX)}
            >
              {OX}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OXPage;
